export { default } from "~/components/product/ProductDetails";

export const eager = true;
export const sync = true;
